import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { ApiError } from 'src/api';
import { $TSFixMe } from 'src/interface';

type ThunkArgs = { rejectValue: ApiError };

export const createAsyncThunkFromFetch = <R, S>(
  prefix: string,
  req: (state?: $TSFixMe) => Promise<AxiosResponse<R>>,
): ReturnType<() => AsyncThunk<R, S, ThunkArgs>> =>
  createAsyncThunk<R, S, ThunkArgs>(prefix, async (state, thunkAPI) => {
    try {
      const response = await req(state);

      if (response?.status >= 400 || !response) {
        return thunkAPI.rejectWithValue({
          code: 'error.unknownError',
          ...(<ApiError>response?.data || {}),
        });
      }

      return response.data;
    } catch (e) {
      console.error(e);
      return {} as Record<string, unknown> as never;
    }
  });

export default createAsyncThunkFromFetch;
